const CALCULATED = '-calculated';

export default function (selector = '.stopper-bubble') {
    if (_gg.isLive) {
        let bubbles = [...document.querySelectorAll(selector)];

        bubbles.forEach((element) => {
            element.classList.remove(CALCULATED);
            const TARGET_SIZE = element.offsetWidth * 0.6;
            let children = [...element.childNodes];
            children.forEach((child) => {
                let scale = TARGET_SIZE / child.offsetWidth;
                child.style.transform = `scale(${scale})`;
            });
            element.classList.add(CALCULATED);
        });
    }
}
